/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PleaseCallMe_viewer = {
    readonly pleaseCallMeConfig: ReadonlyArray<{
        readonly name: string;
    }> | null;
    readonly " $refType": "PleaseCallMe_viewer";
};
export type PleaseCallMe_viewer$data = PleaseCallMe_viewer;
export type PleaseCallMe_viewer$key = {
    readonly " $data"?: PleaseCallMe_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"PleaseCallMe_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PleaseCallMe_viewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PleaseCallMeConfig",
      "kind": "LinkedField",
      "name": "pleaseCallMeConfig",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '466a4d97f1fa5b46952c0088f78716c2';
export default node;
